module.exports = __webpack_public_path__ + "static/2-e7fe42e9ef0e45e2cc2f3d705e663daf.jpg";